module.exports = __webpack_public_path__ + "static/bottom-line-26c08556f248599a56dc0733ba19cf8f.png";